export const MOBILE_BREAKPOINT = 600
export const TABLET_BREAKPOINT = 1023
